import { Country, State, City } from "country-state-city";

const COUNTRIES = Country.getAllCountries()
  .slice()
  .sort((a, b) => a.name.localeCompare(b.name));

export const getCountryNames = () => COUNTRIES.map((c) => c.name);

export const getCountryIso = (name) =>
  COUNTRIES.find((c) => c.name === name)?.isoCode || null;

const DIVISION_LABELS = {
  "United States": "State",
  Canada: "Province",
  "United Arab Emirates": "Emirate",
  "United Kingdom": "County",
  India: "State",
  Pakistan: "Province",
  Australia: "State",
  Malaysia: "State",
  Bangladesh: "Division",
  Germany: "State",
  Netherlands: "Province",
  Switzerland: "Canton",
  Ireland: "County",
  France: "Region",
  "Saudi Arabia": "Region",
  Indonesia: "Province",
  Turkey: "Province",
  "South Africa": "Province",
  "New Zealand": "Region",
  "Sri Lanka": "Province",
  Nigeria: "State",
  Kenya: "County",
};

export const getDivisionLabel = (countryName) =>
  DIVISION_LABELS[countryName] || "State / Province";

export const getStateNames = (countryName) => {
  const iso = getCountryIso(countryName);
  if (!iso) return [];
  return [
    ...new Set(State.getStatesOfCountry(iso).map((s) => s.name).filter(Boolean)),
  ].sort();
};

export const getCityNames = (countryName, stateName) => {
  const iso = getCountryIso(countryName);
  if (!iso) return [];
  const state = State.getStatesOfCountry(iso).find((s) => s.name === stateName);
  const list = state
    ? City.getCitiesOfState(iso, state.isoCode)
    : City.getCitiesOfCountry(iso);
  return [...new Set(list.map((c) => c.name).filter(Boolean))].sort();
};

export const NATIONALITIES = [
  "American", "Australian", "Bahraini", "Bangladeshi", "British", "Canadian",
  "Danish", "Dutch", "Egyptian", "Emirati", "Fijian", "Finnish", "French",
  "German", "Ghanaian", "Guyanese", "Indian", "Indonesian", "Iranian",
  "Iraqi", "Irish", "Italian", "Jordanian", "Kenyan", "Kuwaiti", "Lebanese",
  "Malaysian", "Maldivian", "Mauritian", "Moroccan", "Nepalese", "Nigerian",
  "Norwegian", "Omani", "Other", "Pakistani", "Palestinian", "Portuguese",
  "Qatari", "Saudi", "Singaporean", "Somali", "South African", "Spanish",
  "Sri Lankan", "Sudanese", "Swedish", "Swiss", "Syrian", "Trinidadian",
  "Tunisian", "Turkish", "Yemeni",
].sort();
